import i18n from './i18n';

export const transactionClass = type => ['deposit', 'qr_received'].includes(type) ? 'tx-deposit' : ['withdraw', 'qr_payment'].includes(type) ? 'tx-withdraw' : type === 'transfer' ? 'tx-transfer' : '';

export const CURRENCIES = [
  { code: 'EUR', symbol: '€', label: 'Euro' },
  { code: 'USD', symbol: '$', label: 'US Dollar' },
  { code: 'TRY', symbol: '₺', label: 'Turkish Lira' },
  { code: 'GBP', symbol: '£', label: 'Pound Sterling' },
];

export const currencySymbol = code => CURRENCIES.find(currency => currency.code === code)?.symbol || code;

export const TRANSACTION_TYPES = [
  { value: 'deposit', label: 'Cash Deposit' },
  { value: 'withdraw', label: 'Cash Withdrawal' },
  { value: 'transfer', label: 'Account to Account' },
];

export const STAFF_TABS = [
  { to: '/app/journal', label: 'Customer Journal' },
  { to: '/app/journal/report', label: 'Journal Report' },
  { to: '/app/statement', label: 'Account Statement' },
  { to: '/app/customers', label: 'Customer List' },
  { to: '/app/customers/new', label: 'Add Customer' },
  { to: '/app/loans', label: 'Loans', perm: 'loans' },
  { to: '/app/reports', label: 'Balance Summary', perm: 'balanceSummary' },
];

export const PERMISSION_LABELS = {
  loans: { title: 'Give & repay loans', desc: 'Staff can issue loans and record repayments.' },
  balanceSummary: { title: 'See Balance Summary', desc: 'Staff can open the all-customers balance report.' },
  deleteTransactions: { title: 'Delete journal entries', desc: 'Staff can delete posted or pending transactions.' },
  scanPayments: { title: 'Scan customer QR', desc: 'Staff can scan PIN-approved withdrawal QR codes and confirm cash handover.' },
};

export function can(user, perm) {
  return !!(user?.kind === 'staff' && user?.permissions?.[perm]);
}

export const RECEIPT_TITLES = {
  deposit: 'DEPOSIT RECEIPT',
  withdraw: 'WITHDRAWAL RECEIPT',
  transfer: 'ACCOUNT TO ACCOUNT RECEIPT',
  loan: 'LOAN RECEIPT',
  loan_repayment: 'LOAN REPAYMENT RECEIPT',
  loan_adjustment: 'LOAN ADJUSTMENT RECEIPT',
  qr_payment: 'QR PAYMENT RECEIPT', qr_received: 'PAYMENT RECEIVED',
};

export const TYPE_LABELS = {
  deposit: 'Deposit', withdraw: 'Withdrawal', transfer: 'Account to Account', loan: 'Loan', loan_repayment: 'Loan repayment', loan_adjustment: 'Loan adjustment',
  qr_payment: 'QR payment', qr_received: 'QR payment received',
};

export function homeFor(user) {
  if (!user) return '/login';
  if (user.kind === 'owner') return '/owner';
  if (user.kind === 'staff') return '/app/dashboard';
  return '/portal';
}

export function money(n) {
  return Number(n || 0).toLocaleString(i18n.resolvedLanguage, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const currencyAmount = (currency, amount) => `${currencySymbol(currency)} ${money(amount)}`;

